// External-Dependencies
import { isUndefined, pickBy } from 'lodash';

// WP-Dependencies
import { Component } from '@wordpress/element';
import { PanelBody, QueryControls } from '@wordpress/components';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';
// import { __ } from '@wordpress/i18n';
// import { dateI18n, format, __experimentalGetSettings } from '@wordpress/date';
import { InspectorControls } from '@wordpress/block-editor';
import { withSelect } from '@wordpress/data';
import { decodeEntities } from '@wordpress/html-entities';

//Constants
import {
	MIN_EXCERPT_LENGTH,
	MAX_EXCERPT_LENGTH,
	MAX_POSTS_COLUMNS,
} from './constants';

//"GLOBALS"
const CATEGORIES_LIST_QUERY = {	per_page: -1 };
var activeCategory = {};


export default function saveSocialMediaShare ( props ) {

//	console.log("1-Save");
//	console.log(props);
        
        const { category, date } = props.attributes;

	return(
                <>
                    <p class="gtue-news-header">
                        <span class="gtue-news-header-cat">{props.attributes.category}</span>
                        <span class="gtue-news-header-date">{props.attributes.date}</span>
                    </p>
                </>

        );
}




